export const css = {
	root: '_3Y4HqBjx',
	card: '_2qw6uU5v',
	title: '_22XXV9iY',
	activity_intro: 'B5gA8GZC',
	teach_me: '_12amF0sN',
	teach_me_tooltip: '_18kJKfVE',
	quiz_me: '_1RRkkdU4',
	quiz_me_tooltip: '_1-WogH5P',
	icon: 'NoY-O_Gr',
	close: '_3bbVETtY',
	skel: '_1kUTLp0v',
	skelWithTooltip: '_3KoCOwCM',
	enter: '_3zsFhw-v',
	'slide-in': '_1XTJ0cRr',
	exit: '_26z0sMFe',
	'slide-out': 'QLF7dv4K',
	expanded_content: 'prfCQW-a',
	twoColumn: 'xWqbaCP8',
	shortDesc: '_2Hlzx77h',
	topicgroups: '_2f1Cwpgj',
	item: '_1u3pN4Rv',
	topicquiz: '_2FntYbhu',
	' _key': 'ascm-theme/ascm/card/expanded'
};

export default css;
